import type { PartnerProductInsightsAPIPartner } from 'src/services/partner-product-insights-api/types/PartnerProductInsightsAPIPartner';
import type { PartnerInsights } from '../types';

export const adaptPartnerInsightsForStore = (
  partnerInsights: PartnerProductInsightsAPIPartner,
): PartnerInsights => {
  const { scores, type: _type, ...rest } = partnerInsights;

  return {
    ...rest,
    scores: {
      ...(scores.arrivedOnTime
        ? {
            arrivedOnTime: {
              score: scores.arrivedOnTime.score,
              totalResponses: scores.arrivedOnTime.total_responses,
            },
          }
        : {}),
      ...(scores.hasRecommendedNOTHS
        ? {
            hasRecommendedNOTHS: {
              score: scores.hasRecommendedNOTHS.score,
              totalResponses: scores.hasRecommendedNOTHS.total_responses,
            },
          }
        : {}),
      ...(scores.neededToContactSeller
        ? {
            neededToContactSeller: {
              score: scores.neededToContactSeller.score,
              totalResponses: scores.neededToContactSeller.total_responses,
            },
          }
        : {}),
      ...(scores.valueForMoney
        ? {
            valueForMoney: {
              score: scores.valueForMoney.score,
              totalResponses: scores.valueForMoney.total_responses,
            },
          }
        : {}),
      ...(scores.wasTheProductAsAdvertised
        ? {
            wasTheProductAsAdvertised: {
              score: scores.wasTheProductAsAdvertised.score,
              totalResponses: scores.wasTheProductAsAdvertised.total_responses,
            },
          }
        : {}),
    },
  };
};
